/* eslint-disable */
import HttpService from '../HttpService'

export default class MovementRecordTypeService {
  constructor() {
    this._httpService = new HttpService('/sdi/movement-record-type');
  }

  async FindAll() {
    return await this._httpService.get('');
  }
}
